import { createRoute, useNavigate } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { ToolsPage } from '../../ToolsPage'
import { toolsSearchSchema } from '../search-schemas'

// /tools — таб (catalog | drillstrings) + редактор. Всё в search-параметрах
// одного роута: tab переключает вкладку, edit/new открывают редактор активной
// вкладки. Дефолтный таб — catalog (когда tab=undefined в URL).
//
// При смене таба сбрасываем edit/new — иначе ?edit=N от каталога застрянет на
// вкладке drillstrings и наоборот (id'ы из разных доменов: uuid vs i32).
export const toolsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/tools',
  validateSearch: toolsSearchSchema,
  component: ToolsRouteComponent,
})

function ToolsRouteComponent() {
  const search = toolsRoute.useSearch()
  const navigate = useNavigate()
  const tab = () => search().tab ?? 'catalog'
  return (
    <ToolsPage
      tab={tab()}
      editId={search().edit ?? null}
      create={search().new === 1}
      onTabChange={(t) => navigate({ to: '/tools', search: t === 'catalog' ? {} : { tab: t } })}
      onOpen={(id) =>
        navigate({
          to: '/tools',
          search: tab() === 'catalog' ? { edit: id } : { tab: 'drillstrings', edit: id },
        })
      }
      onCreate={() =>
        navigate({
          to: '/tools',
          search: tab() === 'catalog' ? { new: 1 } : { tab: 'drillstrings', new: 1 },
        })
      }
      onBack={() =>
        navigate({
          to: '/tools',
          search: tab() === 'catalog' ? {} : { tab: 'drillstrings' },
        })
      }
      onOpenTool={(id) => navigate({ to: '/tools', search: { edit: id } })}
    />
  )
}
